import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { Typography } from 'antd'
import * as ST from './styles'
import LanguageSelector from '../../molecules/LanguageSelector'
import logo from '../../../assets/shping_logo.svg'

const LandingTemplate = ({ children, ...props }) => {
  return (
    <ST.Wrapper {...props}>
      <ST.StyledLogo>
        <img src={logo} alt='logo' height='128px' />
        <LanguageSelector />
      </ST.StyledLogo>
      <ST.StyledNavBorder />
      <ST.MainContainer>
        <ST.Content>{children}</ST.Content>
      </ST.MainContainer>
      <Typography.Text style={{ marginTop: -100, color: '#B2B3B2', fontSize: 14, fontWeight: 500 }} strong>
        &copy; {new Date().getUTCFullYear()} - {intl.get('navigation.header')}
      </Typography.Text>
    </ST.Wrapper>
  )
  /* eslint-enable global-require */
}

LandingTemplate.propTypes = {
  children: PropTypes.node.isRequired
}

export default LandingTemplate
